// instagram
var accessToken = $("#mh-instagram-container");

var instagram = {
        init: function() {
            var insta_width = null;
            var app = new Vue({
                el: "#mh-instagram-container",
                data: {
                    instagram: [],
                    profileLink: ''
                },
                created() {
                    $.ajax({
                        url: "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + $("#mh-instagram-container").data('instagram') + "&count=4",
                        dataType: "jsonp",
                        timeout: 5000,
                        success: function(data) {
                            app.instagram = data.data;
                            console.log(data.data);
                            try {
                                app.profileLink = "https://www.instagram.com/" + data.data[0].user.username;
                            } catch (e) {
                                // statements
                                console.log("cannot find profileLink");
                            }

                            setTimeout(function() {
                                // $(".box img").matchHeight();
                                insta_width = $(".photo img").width();
                                $(".photo img").css("max-height", insta_width);
                                console.log("matchHeight");

                            }, 500)

                        },
                        error: function() {
                            console.log("error");
                        }
                    });
                }
            });
            $(function() {

                $(window).bind('resize', function(e) {
                    window.resizeEvt;
                    $(window).resize(function() {
                        clearTimeout(window.resizeEvt);
                        window.resizeEvt = setTimeout(function() {
                            $(".photo img").css("max-height", "100%");
                            // $(".box img").matchHeight();
                            insta_width = $(".photo img").width();
                            $(".photo img").css("max-height", insta_width);
                            console.log("matchHeight: " + insta_width);
                        }, 250);
                    });
                });


            })
        }
    }
$(function () {
  if (accessToken.length) {
        instagram.init();
    }
  $('.toggleMobileMenu').click(function(e){
     e.preventDefault();
     $('.mainMobileMenu').slideToggle();
 });
 function closeWheel(){
 document.querySelector(".spinwin_parent").style.transform ="translate(-100%, 0px) !important";
 // $(".spinwin_parent.evm_front_wheele").removeClass('active')
 document.querySelector(".spinwin_parent").classList.add("spinwin_parent.evm_front_wheele");
 console.log("close the wheel");
 }
 setTimeout(function () {
   $(".exitintel-persistent,.privy-dismiss-content").on("click", function(e) {
     e.preventDefault();
     $(".spinwin_parent.evm_front_wheele").toggleClass('active')
   })
   $(".exitintel-persistent").fadeIn();
   $(".exitintel-persistent").on("click", function(e) {
     $(".exitintel-persistent").fadeOut();
     // $(".spinwin_parent.evm_front_wheele").toggleClass('active')
     setTimeout(function () {
       $(".privy-dismiss-content").on("click", function(e) {
         e.preventDefault();
         $(".spinwin_parent.evm_front_wheele").toggleClass('active')
       })
     },1000)
   })
 },4500);

 $('.mobile-menu').find('.expand').click(function(e){
     e.preventDefault();
     var that = this;
     $(that).closest('.menu-item').find('.sub-menu').slideToggle('fast', function(){
         if($(this).is(':visible')) {
             $(that).addClass('expanded');
         } else {
             $(that).removeClass('expanded');
         }
     });
 });

 // add to cart when click
 $(".getStartedBtn").on("click", function(event) {
   event.preventDefault();
   $(".product-form").submit()
 })
})
